import React, {useState, useEffect} from 'react';
import ParticipanteService from '../services/ParticipanteService';
import UsuarioService from '../services/UsuarioService';
import CampanhaService from '../services/CampanhaService';
import {useHistory, useParams} from "react-router-dom";
import { stringLiteralTypeAnnotation } from '@babel/types';
import {useStore} from 'react-redux';

function AtivarParticipante() {

    const i18n = useStore().getState().i18n
    const [erro, setErro] = useState(null)

    const participanteService = new ParticipanteService()
    const usuarioService = new UsuarioService()
    const campanhaService = new CampanhaService()
    const [processando, setProcessando] = useState(false)

    const history = useHistory()
    let {code} = useParams()

    useEffect(() => {
        if (!processando) {
            setProcessando(true)
            participanteService.ativarParticipante(code, (erro, autenticacao) => {
                if (erro) {
                    if(erro.response && erro.response.data && erro.response.data.message){
                        setErro(i18n.message("ativarParticipante.erro.prefixo", "Erro ao ativar participante: ") + erro.response.data.message)
                    } else {
                        setErro(i18n.message("ativarParticipante.erro.prefixo", "Erro ao ativar participante: ") + erro)
                    }
                    return
                }
                if (autenticacao) {
                    let campanhaCorrente = campanhaService.campanhaCorrente()
                    usuarioService.setUsuarioCorrente(autenticacao)
                    if(!campanhaCorrente || campanhaCorrente.code !== autenticacao.campaignCode){
                        history.push("/campaign/" + autenticacao.campaignCode)
                    } else {
                        history.push("/")
                    }
                }
            })
        }
    }, []);

    return (<div>{erro}</div>)
}

export default AtivarParticipante